import { Color, Flex, Icon, Text } from "src/elements";
import styled from "styled-components";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";

const OverflowingContainer = styled(Flex)<Props>`
  position: absolute;
  flex-direction: column;
  bottom: ${({ shelf, scaleY }) =>
    `calc(${shelf.type === "HANGCELL" ? -shelf.getHeight() : shelf.thickness}px * ${scaleY})`};
  left: 0;
  width: 100%;
  height: ${({ shelf, scaleY }) =>
    `calc(${shelf.getHeight() + (shelf.type === "HANGCELL" ? shelf.thickness : -shelf.thickness)}px * ${scaleY})`};
  border-bottom: 2px solid ${Color.red};
  pointer-events: none;
  z-index: ${({ shelf }) => (shelf.type === "HANGCELL" ? 3 : 1)};
`;

const OverflowingLabel = styled(Flex)`
  position: absolute;
  bottom: 4px;
  left: 4px;
  align-items: center;
  width: min-content;
  padding: 2px 6px;
  gap: 4px;
  background-color: ${Color.red};
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
`;

interface Props {
  shelf: PlanogramShelf;
  scaleY: number;
}

export const Overflowing = ({ shelf, scaleY }: Props) => (
  <OverflowingContainer data-testid="overflowing-warning" shelf={shelf} scaleY={scaleY}>
    <OverflowingLabel>
      <Icon name="alert" color={Color.white} size={14} />

      <Text variant="small3" color={Color.white}>
        Overflowing
      </Text>
    </OverflowingLabel>
  </OverflowingContainer>
);
